export default __webpack_public_path__ + "static/daheim-cf9d23f21d062e5bcf9caf120b195c7e.jpg";